/*
  Behavior port for the homepage (vit2go-nl-homepage-landing-page.html):
  scroll-reveal only — no product selector/cart on this page.
*/
(function () {
  "use strict";

  function init(root) {
    root.classList.add("js");
    var hero = root.querySelector(".hero");
    requestAnimationFrame(function () {
      root.querySelectorAll(".hero .r").forEach(function (el) { el.classList.add("in"); });
    });
    var targets = [].filter.call(root.querySelectorAll(".r"), function (el) {
      return !hero || !hero.contains(el);
    });
    if (!("IntersectionObserver" in window)) {
      targets.forEach(function (el) { el.classList.add("in"); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add("in"); io.unobserve(entry.target); }
        });
      }, { rootMargin: "0px 0px 200px 0px", threshold: 0 });
      targets.forEach(function (el) { io.observe(el); });
    }
  }

  function boot() {
    document.querySelectorAll("[data-v2g-homepage]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", boot);
  }
})();
